<template>
  <div class="min-h-screen bg-gradient-to-br from-red-50 via-white to-orange-50 flex items-center justify-center px-4">
    <div class="max-w-md w-full">
      <div class="bg-white rounded-2xl shadow-2xl p-8 text-center border border-red-100">
        <div class="mb-6">
          <div class="inline-flex items-center justify-center w-20 h-20 bg-red-100 rounded-full mb-4">
            <svg class="w-10 h-10 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
            </svg>
          </div>
          <h1 class="text-3xl font-bold text-gray-800 mb-2">Acesso Negado</h1>
          <div class="w-16 h-1 bg-red-500 mx-auto rounded-full"></div>
        </div>

        <div class="mb-8">
          <p class="text-gray-600 text-lg leading-relaxed">
            Não tem permissões para aceder a esta página.
          </p>
          <p class="text-gray-500 text-sm mt-2">
            Entre em contacto com o administrador se necessário.
          </p>
        </div>

        <div class="space-y-3">
          <router-link
            :to="dashboardRoute"
            class="block w-full bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white font-semibold py-3 px-6 rounded-xl transition-all duration-300 transform hover:scale-105 hover:shadow-lg"
          >
            <span class="flex items-center justify-center">
              <svg class="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
              </svg>
              Ir para o Dashboard
            </span>
          </router-link>

          <button
            @click="goBack"
            class="block w-full bg-gray-100 hover:bg-gray-200 text-gray-700 font-medium py-3 px-6 rounded-xl transition-all duration-300"
          >
            <span class="flex items-center justify-center">
              <svg class="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 19l-7-7m0 0l7-7m-7 7h18" />
              </svg>
              Voltar
            </span>
          </button>
        </div>
      </div>

      <div class="text-center mt-6">
        <p class="text-gray-500 text-sm">
          Sistema de Gestão de Segurança
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotAuthorizedView',
  computed: {
    dashboardRoute() {
      // Check if user is logged in and get user data
      try {
        const userData = JSON.parse(localStorage.getItem('user'));
        const userType = userData?.tipo?.nome;

        // If user is a technician, redirect to tecnico dashboard
        if (userType === 'tecnico') {
          return '/tecnico/dashboard';
        }

        // For all other users, redirect to main dashboard
        return '/dashboard';
      } catch (error) {
        // If there's an error parsing user data, default to main dashboard
        console.warn('Error parsing user data:', error);
        return '/dashboard';
      }
    }
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    }
  }
};
</script>
  